module.exports = __webpack_public_path__ + "static/media/crocodile.39955867.wav";